import React, { useMemo } from 'react';
import { useContent } from '../../context/ContentContext';
import { resolveMediaUrl } from '../../utils/api';
import { formatRupiah } from '../../utils/formatters';
import { Sparkles } from 'lucide-react';
import { motion } from 'motion/react';

export const SpecialForYouSection: React.FC = () => {
  const { data } = useContent();
  
  const activeItems = useMemo(() => {
    return (Array.isArray(data.specialForYou) ? data.specialForYou : [])
      .filter((item) => item.is_active)
      .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));
  }, [data.specialForYou]);

  if (activeItems.length === 0) return null;

  return (
    <section id="special-for-you" className="py-12 sm:py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 mb-6 px-4">
          <Sparkles className="w-5 h-5 text-[#0056D2]" />
          <h2 className="font-display font-black text-xl sm:text-2xl text-[#0A192F] uppercase tracking-tight">
            Spesial Untukmu
          </h2>
        </div>

        <div className="flex overflow-x-auto gap-4 px-4 pb-4 hide-scrollbar snap-x snap-mandatory">
          {activeItems.map((item) => (
            <div
              key={item.id}
              className="bg-[#F8FAFC] rounded-3xl p-4 border border-[#E2E8F0] shadow-sm flex flex-col shrink-0 w-[80%] sm:w-[350px] snap-start"
            >
              <div className="aspect-video w-full rounded-2xl overflow-hidden mb-4 bg-slate-200">
                <img
                  src={resolveMediaUrl(item.image_url)}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  referrerPolicy="no-referrer"
                />
              </div>
              <h3 className="font-bold text-lg text-[#0A192F] truncate">{item.title}</h3>
              <p className="text-sm text-slate-600 mb-4 flex-1 line-clamp-2">{item.description}</p>
              <div className="text-[#0056D2] font-bold">
                {formatRupiah(item.price)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
